export type UiLanguageDictionary = Record<string, string>;

const placeholders = (value: string): string =>
  [...value.matchAll(/\{\{\s*(\w+)\s*\}\}/g)].map(match => match[1]).sort().join('|');

// The generated API returns a Blob, but its content is a flat JSON dictionary.
export function parseLanguagePack(content: string): UiLanguageDictionary {
  const payload: unknown = JSON.parse(content.replace(/^\uFEFF/, ''));
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    throw new Error('Invalid UI language package: expected a JSON object.');
  }
  const dictionary: UiLanguageDictionary = Object.create(null);
  for (const [key, value] of Object.entries(payload)) {
    if (['__proto__', 'constructor', 'prototype'].includes(key)) continue;
    if (typeof value !== 'string' || !value.trim() || placeholders(key) !== placeholders(value)) continue;
    dictionary[key] = value;
  }

  // Older templates use these punctuation/name variants. Derive them from the
  // backend values only, without overwriting an explicit backend translation.
  const alias = (key: string, source: string, prefix = '', suffix = '') => {
    if (!Object.prototype.hasOwnProperty.call(dictionary, key) && dictionary[source]) {
      dictionary[key] = prefix + dictionary[source] + suffix;
    }
  };
  for (const label of ['Subtotal', 'Tax', 'Total']) alias(label + ':', label, '', ':');
  alias('(Success)', 'Success', '(', ')');
  alias('(Failed)', 'Failed', '(', ')');
  alias('Admin Settings', 'Administrator Settings');
  alias("Today's Order No.:", "Today's Order No.", '', ':');
  return dictionary;
}
